// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOperationsFilePngOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 20a1 1 0 0 0 1-1v-9h-5a1 1 0 0 1-1-1V4H7a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1zm.672-12L14 4.328V8zm-4-6a2 2 0 0 1 1.414.586l4.328 4.328A2 2 0 0 1 20 8.328V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3zm1.779 11.57h1.702c-.009.486-.053.753-.175 1.016-.272.6-.81.932-1.519.932-1.04 0-1.758-.713-1.758-1.75 0-1.055.726-1.768 1.79-1.768.703 0 1.172.293 1.482.928l-.814.337c-.148-.36-.376-.526-.708-.526-.49 0-.853.442-.853 1.033 0 .302.109.604.297.8.14.158.337.241.582.241a.696.696 0 0 0 .56-.245.699.699 0 0 0 .118-.332h-.704zM7 15.4v-3.3h1.36c.386 0 .613.075.828.28.21.202.319.469.319.815 0 .328-.092.608-.267.8-.184.21-.455.306-.849.306h-.533V15.4zm1.61-2.197c0-.275-.153-.415-.468-.415h-.284v.827h.28c.328 0 .472-.127.472-.412zm2.155-1.102 1.575 2.017V12.1h.858V15.4h-.858l-1.575-2.017V15.4h-.857v-3.3z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgOperationsFilePngOutline;
